export const enum STATUS_CODES {
  OK = 200,
  CREATED = 201,
  DELETED = 202,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  PAYMENT_REQUIRED = 402,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  TOO_MANY_REQUESTS = 429,
  SERVER_ERROR = 500,
  SERVICE_UNAVAILABLE = 503,
}
